var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type=='edit')?_c('div',[(_vm.extendMetaData != null && _vm.extendMetaData.length != 0)?[_c('el-divider',[_c('span',{staticStyle:{"color":"#409eff"}},[_vm._v("扩展信息")])]),_vm._l((_vm.extendMetaData),function(item){return [(item.type == 1)?_c('el-form-item',{key:item.id,attrs:{"prop":item.code,"label":item.label,"rules":[
              {
                required:
                  item.isRequired == null || item.isRequired == 0
                    ? false
                    : true,
                message: '请输入' + item.label,
                trigger: 'blur',
              },
              {
                max: item.maxSize == null ? 100 : item.maxSize,
                message: '不能超过' + item.maxSize + '个字符',
                trigger: 'blur',
              },
            ]}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":'请输入' + item.label,"clearable":""},on:{"blur":_vm.change},model:{value:(_vm.data[item.code]),callback:function ($$v) {_vm.$set(_vm.data, item.code, $$v)},expression:"data[item.code]"}})],1):_vm._e(),(item.type == 2)?_c('el-form-item',{key:item.id,attrs:{"prop":item.code,"label":item.label,"rules":[
              {
                required:
                  item.isRequired == null || item.isRequired == 0
                    ? false
                    : true,
                message: '请选择' + item.label,
                trigger: 'blur',
              },
            ]}},[_c('el-select',{ref:item.code,refInFor:true,staticStyle:{"width":"200px"},attrs:{"placeholder":'请选择' + item.label,"clearable":"","filterable":""},on:{"change":_vm.change},model:{value:(_vm.data[item.code]),callback:function ($$v) {_vm.$set(_vm.data, item.code, $$v)},expression:"data[item.code]"}},_vm._l((item.dicts),function(i){return _c('el-option',{key:i.id,attrs:{"label":i.name,"value":i.value}})}),1)],1):_vm._e(),(item.type == 3)?_c('el-form-item',{key:item.id,attrs:{"prop":item.code,"label":item.label,"rules":[
              {
                required:
                  item.isRequired == null || item.isRequired == 0
                    ? false
                    : true,
                message: '请输入' + item.label,
                trigger: 'blur',
              },
              {
                max: item.maxSize == null ? 100 : item.maxSize,
                message: '不能超过' + item.maxSize + '个字符',
                trigger: 'blur',
              },
            ]}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"textarea","rows":2,"placeholder":'请输入' + item.label,"clearable":""},on:{"blur":_vm.change},model:{value:(_vm.data[item.code]),callback:function ($$v) {_vm.$set(_vm.data, item.code, $$v)},expression:"data[item.code]"}})],1):_vm._e()]})]:_vm._e()],2):_vm._e(),(_vm.type=='view')?_c('div',[(_vm.extendData != null && _vm.extendData.length != 0)?[_c('el-tabs',{attrs:{"type":"card"}},[_c('el-tab-pane',{attrs:{"label":"扩展信息"}},[_c('el-descriptions',{staticStyle:{"cursor":"pointer","margin-bottom":"12px"},attrs:{"column":3,"size":"mini","border":""}},[_vm._l((_vm.extendData),function(item,index){return [(item.value !== ''&&item.value!=null)?_c('el-descriptions-item',{key:index,attrs:{"label":item.label,"labelStyle":_vm.labelStyle}},[_vm._v(_vm._s(item.value))]):_vm._e()]})],2)],1)],1)]:_vm._e()],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }